import momentTz from 'moment-timezone';
import type {
  OrderHistoryDateField,
  OrderHistoryReportItem
} from 'washday-sdk';

export type OrderHistoryReportRow = OrderHistoryReportItem;

const columnIds = [
  'folio',
  'selectedDate',
  'customerName',
  'storeName',
  'status',
  'pickup',
  'delivery',
  'total',
  'paid',
  'balance'
] as const;

export const buildOrderHistoryReportColumnIds = () => [...columnIds];

export const formatHomeServiceIndicator = (enabled: boolean, yesLabel: string) =>
  enabled ? yesLabel : '—';

export const formatOrderHistoryDate = (
  value: string | null | undefined,
  storeTimezone: string,
  dateField: OrderHistoryDateField
) => {
  if (!value) return '-';
  const parsed = momentTz(value);
  if (!parsed.isValid()) return '-';
  const timezone = dateField === 'pickupScheduled' ? 'UTC' : storeTimezone || 'UTC';
  return parsed.tz(timezone).format('DD/MM/YYYY HH:mm');
};

export const buildOrderHistoryReportRows = (
  orders: OrderHistoryReportItem[]
): OrderHistoryReportRow[] => orders.map((order) => ({ ...order }));
